export default __webpack_public_path__ + "static/media/meal2.6070474c.jpg";